// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mission-page .sec-title__tagline {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.mission-page .sec-title__tagline span {
  flex: 1 1;
  height: 2px;
  background-color: #ddd;
}

.mission-page .sec-title__tagline h6 {
  margin: 0 20px;
  font-size: 18px;
  text-transform: uppercase;
  color: #ff5e14;
}

.mission-page .sec-title__title {
  /* font-size: 36px;
  font-weight: bold;
  text-transform: uppercase;
  color: #333; */
  text-align: center;

  position: relative;
  display: inline-block;
  color: #333;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  text-transform: uppercase;
}

.mission-page .work-perfomance-one__img {
  text-align: center;
}

.mission-page .work-perfomance-one__img img {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out;
}

.mission-page .work-perfomance-one__img:hover img {
  transform: scale(1.05);
}

.mission-page .work-perfomance-one__content {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease-in-out;
}

.mission-page .work-perfomance-one__content:hover {
  background-color: #fff;
}

.mission-page .sec-title__text {
  text-align: justify;
  font-size: 16px;
  color: #555;
}

.mission-page .bullet-point {
  font-size: 15px;
  color: #00000078;
  margin-bottom: 12px;
  list-style-type: disc;
  margin-left: 20px;
  line-height: normal;
  text-align: justify;
}

.mission-page .container {
  max-width: 1200px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MissionPage/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE;;;gBAGc;EACd,kBAAkB;;EAElB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".mission-page .sec-title__tagline {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.mission-page .sec-title__tagline span {\n  flex: 1;\n  height: 2px;\n  background-color: #ddd;\n}\n\n.mission-page .sec-title__tagline h6 {\n  margin: 0 20px;\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #ff5e14;\n}\n\n.mission-page .sec-title__title {\n  /* font-size: 36px;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #333; */\n  text-align: center;\n\n  position: relative;\n  display: inline-block;\n  color: #333;\n  font-size: 20px;\n  line-height: 30px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.mission-page .work-perfomance-one__img {\n  text-align: center;\n}\n\n.mission-page .work-perfomance-one__img img {\n  width: 100%;\n  height: auto;\n  transition: transform 0.3s ease-in-out;\n}\n\n.mission-page .work-perfomance-one__img:hover img {\n  transform: scale(1.05);\n}\n\n.mission-page .work-perfomance-one__content {\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease-in-out;\n}\n\n.mission-page .work-perfomance-one__content:hover {\n  background-color: #fff;\n}\n\n.mission-page .sec-title__text {\n  text-align: justify;\n  font-size: 16px;\n  color: #555;\n}\n\n.mission-page .bullet-point {\n  font-size: 15px;\n  color: #00000078;\n  margin-bottom: 12px;\n  list-style-type: disc;\n  margin-left: 20px;\n  line-height: normal;\n  text-align: justify;\n}\n\n.mission-page .container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
